<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12>
        <basic :inteRegist="item"/>
      </v-flex>
    <!--  <v-flex xs12>
        <manage :inteRegist="item"/>
      </v-flex>-->
    </v-layout>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'

  import Basic from './regist/basic'
  import Manage from './manage/manage'
  import XDelete from '@/components/global/Delete'
  import XReview from '@/components/global/Review'
  import XSubmit from '@/components/global/Submit'
  import XHistory from '@/components/global/History'

  const baseUri = '/api/inte/intellectualRegist';
  const statusUri = '/api/code/status';

  export default {
    components: {XSubmit, XReview, XHistory, XDelete, Basic,Manage},

    data: () => ({
      uri: baseUri,
      item: {
        histories: [],
        status: {},
        actions: []
      },

      fileUri: '/api/inte/file',

      statusItems: [],

      review: false,
      reviewDbid: null,
      reviewMsg: null,
      reviewActs: [],

      hist: false,
      history: [],

    }),

    // 路由进入前，组件就未完成渲染，不可以使用 this
    beforeRouteEnter(to, from, next) {
      window.console.log("In edit_page beforeRouteEnter");
      const dbid = to.params.dbid;

      if (dbid) {
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => next(vm => {
              vm.dbid = dbid;
              vm.item = rsp.data;
              // 保存默认数据
              vm.defaultItem = window.xutil.clone(vm.item);
              vm.loading = false
            })
          )
      } else {
        next();
      }
    },

    // 路由改变前，组件就已经渲染完成，可以使用 this
    beforeRouteUpdate(to, from, next) {
      window.console.log("In edit_page beforeRouteUpdate");

      const dbid = to.params.dbid;
      if (dbid) {
        this.loading = true;
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => {
              this.dbid = dbid;
              this.item = rsp.data;
              // 保存默认数据
              this.defaultItem = window.xutil.clone(this.item);
              this.loading = false;
              next()
            }
          )
      } else {
        next();
      }
    },

    computed: {
      ...mapGetters(['funcIds'])
    },

    created() {
      // 加载审核状态
      this.axios.get(statusUri, {params: {sort: 'rank.asc'}})
        .then(
          rspStaus => {
            this.statusItems = rspStaus.data.items;
          }
        )
    },

    methods: {
      reviewDisabled(item) {
        return !(
          // 当前用户拥有审核功能
          this.funcIds.includes('u_inteRegist_review')
          // 并且，当前记录需要审核
          && item.actions.find(a => ['approve', 'return', 'revoke'].includes(a.action)))
      }
    }
  }
</script>
<style>
  div.dense table.datatable.table td:first-child,
  div.dense table.datatable.table td:not(:first-child),
  div.dense table.datatable.table th:first-child,
  div.dense table.datatable.table th:not(:first-child) {
    padding: 0 8px;
  }
</style>
